<template>
    <header>
        <div class="flex flex-col">
            <div class="flex max-lg:items-center max-lg:justify-between max-lg:px-3.75">
                <BurgerMenu></BurgerMenu>
                <div>
                    <router-link to="/">
                        <AppLogo />
                    </router-link>
                </div>
                <div class="ml-auto flex items-center gap-5 max-lg:hidden">
                    <template v-if="$store.userData?.has_business_account">
                        <router-link :to="{ name: 'myBusinessAccounts' }" class="text-black font-bold text-lg capitalise" :class="getTextAdaptiveStyle">
                            {{ $t('nav.profile') }}
                        </router-link>
                        <router-link :to="{ name: 'complaints' }" class="text-black font-bold text-lg capitalise" :class="getTextAdaptiveStyle">
                            {{ $t('nav.complaints') }}
                        </router-link>
                    </template>
                    <router-link :to="{ name: 'mallOrders' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.orders') }}
                    </router-link>
                    <router-link :to="{ name: 'addresses' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.addresses') }}
                    </router-link>
                    <router-link :to="{ name: 'publicationLiked' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.liked') }}
                    </router-link>
                    
                    <router-link v-if="$store.userData?.has_business_account" :to="{ name: 'myBusinessPublications' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.myPublications') }}
                    </router-link>
                    <router-link v-else :to="{ name: 'myPublications' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.myPublications') }}
                    </router-link>

                    <router-link :to="{ name: 'payments' }" class="text-black font-bold text-lg" :class="getTextAdaptiveStyle">
                        {{ $t('nav.payments') }}
                    </router-link>

                    <router-link :to="{ name: 'comments' }" class="text-black font-bold text-lg capitalise" :class="getTextAdaptiveStyle">
                        {{ $t('nav.comments') }}
                    </router-link>
                    
                    
                </div>
                <div class="hidden max-lg:flex">
                    <LocationButton customClass="mr-4 bg-[#f9f9f9] shadow-sm"></LocationButton>
                    <LanguageSwitcher extraclasswrapper="border-black" extraclasslabel="!text-black"></LanguageSwitcher>
                </div>
            </div>
        </div>
        <div class="flex items-center justify-between">
            
            <div class="mt-5 text-start font-medium underline text-main-color max-lg:text-center">{{ $store.userData?.has_business_account ? $t('page.my_business_account') : $t('page.my_account') }}: <span class="italic">{{ $store.userData?.login }} <br> {{ $store.userData?.username }}</span></div>
            <div class="flex items-center gap-5">
                <button class="text-main-color underline font-bold text-base hover:text-accent-color duration-150 transition-colors" @click="openPasswordResetModal">{{ $t('action.changepassword') }}</button>
                <button
                    class="md:bg-[#CB3131] px-8 text-xs md:text-base whitespace-nowrap md:text-white md:py-3 rounded font-bold hover:bg-red-600 transition-all flex items-center flex-col"
                    @click="logout">
                    <i class="fas fa-sign-out-alt text-lg text-[#cb3131] md:hidden"></i>
                    <span class="hidden md:inline">{{ $t('action.logout') }}</span>
                    <span class="inline md:hidden">{{ $t('action.logout') }}</span>
                </button>

            </div>
        </div>
        <hr class="mt-5">
    </header>
</template>

<script>
import AppLogo from '@cmp/AppLogo.vue'
import BurgerMenu from '@cmp/BurgerMenu.vue'
import LanguageSwitcher from '@cmp/LanguageSwitcher.vue'
import api from '@/api';
import LocationButton from "@cmp/LocationButton.vue";
export default {
    name: 'ProfileHeader',
    components: {
        LocationButton,
        AppLogo,
        BurgerMenu,
        LanguageSwitcher
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        openPasswordResetModal(){
                this.$store.modals.resetPasswordModal = true
        },
        async getOrderSessionId(){
			try{
                const response = await api.post('mall/order-sessions/')
                let orderSessionId = response.data.id
                this.$store.setOrderSessionId(orderSessionId)
			}catch(e){
				console.log(e)
			}
		},
		async getFoodOrderSessionId(){
			try{
                const response = await api.post('exhibition/order-sessions/')
                let orderSessionId = response.data.id
                this.$store.setFoodOrderSessionId(orderSessionId)
			}catch(e){
				console.log(e)
			}
		},
        async logout() {
            this.$store.logoutUser()
            this.$store.deleteOrderSessionId()
            this.$store.deleteFoodOrderSessionId()
            await this.getOrderSessionId()
            await this.getFoodOrderSessionId()
            this.$router.push('/')

        },
    },
    computed: {
        getTextAdaptiveStyle(){
            if (this.$store.userData?.has_business_account){
                return '!text-base'
            }
            else{
                return ''
            }
        }
    },
    created() {

    }
}
</script>
<style scoped>
.router-link-exact-active{
    color: #409DBA;
}
</style>